import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import RogersHeroSection from "./components/HeroSection";
import RogersStickyNav from "./components/StickyNav";
import RogersProcessingTimeSection from "./components/ProcessingTimeSection";
import RogersServicesSection from "./components/ServicesSection";
import RogersLocalAreaSection from "./components/LocalAreaSection";
import RogersTravelTimingSection from "./components/TravelTimingSection";
import RogersDestinationsSection from "./components/DestinationsSection";
import RogersTestimonialsSection from "./components/TestimonialsSection";
import RogersAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import RogersComparisonSection from "./components/ComparisonSection";
import RogersMistakesSection from "./components/MistakesSection";
import RogersHowItWorksSection from "./components/HowItWorksSection";
import RogersFAQSection, { faqs } from "./components/FAQSection";
import RogersHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import RogersFinalCTA from "./components/FinalCTA";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years." },
  { name: "New Passport", description: "First-time passport application assistance for Rogers and Benton County residents." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance." },
  { name: "Corporate Group Processing", description: "Bulk passport processing for Walmart and NWA corporate teams." },
];

export default function RogersPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Rogers"
        state="Arkansas"
        stateAbbr="AR"
        route="/cities/rogers"
        title="Emergency Passport Rogers, AR — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Rogers, AR — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Walmart corporate travelers, Pinnacle Hills families, and all of Benton County."
        geoPlacename="Rogers, Arkansas"
        geoPosition="36.3320;-94.1185"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Arkansas"
        statePageRoute="/states/arkansas"
      />
      <RogersHeroSection />
      <RogersStickyNav />
      <RogersProcessingTimeSection />
      <RogersLocalAreaSection />
      <RogersServicesSection />
      <RogersTravelTimingSection />
      <RogersDestinationsSection />
      <RogersTestimonialsSection />
      <RogersAcceptanceFacilitiesSection />
      <RogersComparisonSection />
      <RogersMistakesSection />
      <RogersHowItWorksSection />
      <RogersFAQSection />
      <RogersHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/rogers" state="AR" />
      <RogersFinalCTA />
    </div>
  );
}